import React, { useState, useEffect } from "react";
import Header from "../nav/Header";
import ReactPaginate from 'react-paginate';

import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardActions,
  CardImage,
  CardSubtitle,
} from "@progress/kendo-react-layout";

function Guides() {
  const [guides, setGuides] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const itemsPerPage = 3;
  const pagesVisited = pageNumber * itemsPerPage;

  useEffect(() => {
    const getGuides = async () => {
      const guidesFromServer = await fetchGuides();
      setGuides(guidesFromServer);
    };
    getGuides();
  }, []);

  //Fetch Guides from API
  const fetchGuides = async () => {
    const res = await fetch("https://saraiapp.com/api/guides");
    const data = await res.json();
    //console.warn(data)
    return data.slice(0,9);
  };

  //data from DB comes with HTML tags, use this to remove it
  const replaceTags = /(<([^>]+)>)/gi;

  //truncate text
  function truncate(str) {
    return str.length > 10 ? str.substring(0, 200) + "..." : str;
  }

  const displayItems = guides
  .slice(pagesVisited, pagesVisited + itemsPerPage)
  .map(guide => {
      return(
          <div className="col-4 mb-3" key={guide.id}>
              <Card>
                <CardImage
                  src={"https://saraiapp.com/" + guide.media}
                  alt={guide.title}
                />
                <div>
                  <CardHeader>
                    <CardTitle>{guide.title}</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <p>{truncate(guide.content.replace(replaceTags, ""))}</p>
                  </CardBody>
                  <CardActions>
                    <button className="k-button k-primary k-flat">
                      Read More
                    </button>
                  </CardActions>
                </div>
              </Card>
            </div>
      )
  })

  const pageCount = Math.ceil(guides.length / itemsPerPage);

  const changePage = ({selected}) => {
      setPageNumber(selected);
  }

  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Guides</h1>
            <h2 className="sub-header mt-0">
              Sarai Guides curated to help you navigate your journey before and
              after birth.
            </h2>
          </div>
        </div>
        <div className="row">
          {displayItems}
        </div>
        <div className="row mt-5">
          <div className="col-12">
            <ReactPaginate 
            previousLabel={"Back"} 
            nextLabel={"Forward"} 
            pageCount={pageCount}
            onPageChange={changePage}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Guides;
